'use client';

import { AuthProvider } from '@/components/AuthContext';
import { Toaster } from '@/components/Toaster';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { BackToTop } from '@/components/BackToTop';

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ErrorBoundary>
      <AuthProvider>
        {children}
        <Toaster />
        <BackToTop />
      </AuthProvider>
    </ErrorBoundary>
  );
}
